// ANGEL FLIGHT — Phaser registry & localStorage key constants.

export const REG = Object.freeze({
  SAVE: 'gunner.save.v2',
  SAVE_STATE: 'gunner.saveState',
  DIFFICULTY: 'gunner.difficulty',
  EVENT_BUS: 'gunner.eventBus',
  PLAYER_STATS: 'gunner.playerStats',
} as const);

export type RegKey = (typeof REG)[keyof typeof REG];
